import { apiClient } from "./api";
import { isAxiosError } from "axios";

class ReintegroService {
    private basicURL: string;

    constructor() {
        this.basicURL = "/Reintegro";
    }

    async postReintegro(reintegro: object){
        const endpoint = `${this.basicURL}/CrearReintegro`;
        const body = JSON.stringify(reintegro);
        try{
            const response = await apiClient.post(endpoint, body);
            return response;
        } catch(error: any){
            if (isAxiosError(error)) {
                return error.response;
            }
            return "Error al crear un reintegro";
        }
    }

    async getReintegrosPaciente(idPaciente: number){
        const endpoint = `${this.basicURL}/GetReintegrosDePaciente`;
        const body = JSON.stringify({id: idPaciente});
        try{
            const response = await apiClient.post(endpoint, body);
            return response;
        } catch(error: any){
            if (isAxiosError(error)) {
                return error.response;
            }
            return "Error al obtener los reintegros del paciente";
        }
    }

    async updateReintegro(reintegro: object){
        const endpoint = `${this.basicURL}/ActualizarReintegro`;
        const body = JSON.stringify(reintegro);
        try{
            const response = await apiClient.post(endpoint, body);
            return response;
        } catch(error: any){
            if (isAxiosError(error)) {
                return error.response;
            }
            return "Error al actualizar un reintegro";
        }
    }
}

export default ReintegroService;